import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import RichTextDisplay from 'Components/UI/RichTextDisplay';

const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`,
  },
  richText: {
    width: '100%',
  },
});

const TitledPaperRichTextDisplay = ({
  classes,
  label,
  value,
}) => {
  return (
    <Box className={classes.root}>
      {label ? (
        <Typography
          variant="h5"
          weight="bold"
          align="left"
        >
          {label}
        </Typography>
      ) : null}
      <RichTextDisplay
        content={value}
        className={classes.richText}
      />
    </Box>
  );
};

TitledPaperRichTextDisplay.defaultProps = {
  label: '',
  value: '',
};

TitledPaperRichTextDisplay.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TitledPaperRichTextDisplay);
